<template>
  <v-container v-if="project.ULF_UUID" class="pr-0 pl-0 pb-0">
    <div v-if="messages.length" style="height: 60vh; overflow-y: auto; overflow-x: hidden;" class="grey lighten-2">
      <div
        v-for="item in messages"
        :key="item.CM_UUID"
        >
        <v-row v-if="item.OWN_COMMENT">
          <v-col cols="10" offset="2"><config-comment-card :comment="item"></config-comment-card></v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="10" align-self="start"><config-comment-card :comment="item"></config-comment-card></v-col>
        </v-row>
      </div>
    </div>
    <div class="fill-height grey lighten-2" v-else>
      <v-row align="center" justify="center" class="fill-height">
        <v-col class="text-center">
          Нет переписки по выбранной конфигурации
        </v-col>
      </v-row>
    </div>
    <v-card class="mt-2 pt-2 pl-2 pr-2">
      <v-textarea
        outlined
        dense
        class="mt-2"
        rows="1"
        auto-grow
        background-color="white"
        v-model="commentText"
        label="Новый комментарий"
        append-outer-icon="mdi-send blue--text"
        @click:append-outer="sendComment"
      ></v-textarea>
    </v-card>
  </v-container>
  <v-row v-else align="center" justify="center" class="fill-height">
    <v-col class="text-center">
      Не задана конфигурация
    </v-col>
  </v-row>
</template>

<script>
import ConfigCommentCard from '@/components/modules/projects/cards/configuration/configCommentCard'
import { RCPT_CHANGE_MESSAGE } from '@/store/actions/receptures'
import { UI_SNACKBAR } from '@/store/actions/ui'
export default {
  name: 'configCommentsList',
  components: { ConfigCommentCard },
  props: {
    project: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: () => ({
    commentText: null
  }),
  computed: {
    messages: {
      get: function () {
        return this.$store.getters.getCurrentReceptureMessages
      }
    }
  },
  methods: {
    sendComment () {
      console.log('sendComment event called', this.commentText)
      if (!this.commentText.trim()) {
        return
      }
      const params = {
        ULF_UUID: this.project.ULF_UUID,
        DOC_COMMENT: this.commentText
      }
      this.$store.dispatch(RCPT_CHANGE_MESSAGE, params)
        .then(() => {
          this.$store.commit(UI_SNACKBAR, { color: 'green lighten-1', text: 'Комментарий добавлен успешно' })
          this.commentText = ''
        })
        .catch(err => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: err })
        })
    }
  }
}
</script>

<style scoped>

</style>
